import i from "react";
import { Icon as c } from "@mui/material";
import '../../assets/Icon.JC037wvi.css';const _ = [
  "add",
  "add_alert",
  "account_circle",
  "apps",
  "arrow_back",
  "arrow_downward",
  "arrow_forward_ios",
  "arrow_upward",
  "assignment",
  "attachment",
  "backup",
  "block",
  "bookmark",
  "bookmark_border_outlined",
  "business",
  "cached",
  "calendar_today",
  "cancel",
  "check",
  "check_circle",
  "chevron_left",
  "chevron_right",
  "chrome_reader_mode",
  "clear",
  "close",
  "comment",
  "content_copy_icon",
  "delete",
  "download",
  "edit",
  "email",
  "error",
  "error_outline",
  "expand_less",
  "expand_more",
  "favorite",
  "favorite_outline",
  "file_upload",
  "filter_list",
  "flag",
  "help",
  "help_outline",
  "history",
  "home",
  "info",
  "insert_drive_file",
  "keyboard_arrow_down",
  "keyboard_arrow_up",
  "launch",
  "list",
  "location_on",
  "lock_open_outlined_icon",
  "lock_outlined_icon",
  "menu",
  "more_horiz",
  "more_vert_icon",
  "person",
  "person_outline",
  "refresh",
  "repeat",
  "report",
  "save",
  "search",
  "settings",
  "share",
  "view_list",
  "visibility",
  "warning",
  "warning_amber"
], s = ["hazmat", "chr-logo"], f = [..._, ...s], r = "material-icons";
function u(a) {
  switch (a) {
    case "twoToned":
      return `${r}-two-tone`;
    case "filled":
      return `${r}`;
    case "rounded":
      return `${r}-round`;
    case "sharp":
      return `${r}-sharp`;
    case "outlined":
    default:
      return `${r}-outlined`;
  }
}
function b({
  variant: a,
  icon: e,
  disabled: o,
  sx: n,
  ...t
}) {
  const d = s.includes(e), l = o === void 0 ? !1 : o;
  return d ? /* @__PURE__ */ i.createElement(
    c,
    {
      baseClassName: "chr-icons",
      "aria-label": t["aria-label"] ?? e,
      "aria-disabled": l,
      sx: n
    },
    `${e}-${a === "filled" ? "filled" : "outlined"}`
  ) : /* @__PURE__ */ i.createElement(
    c,
    {
      "aria-label": t["aria-label"] ?? e,
      "aria-disabled": l,
      baseClassName: u(a),
      sx: n
    },
    e
  );
}
export {
  b as I,
  f as a
};
